<template>
  <v-card class="rounded-xl attachment-repair-file" :border="false" :elevation="0">
    <v-col cols="12">
      <p class="title">
        {{ $t('REPAIR_FILE_ATTACHMENT.TITLE') }}
      </p>
      <p class="sub-title" v-if="!checkPermission(['DISTRIBUTOR_VIEW_ATTACHMENT_REPAIR_FILE'])">
        {{ $t('REPAIR_FILE_ATTACHMENT.PERMISSION.VIEW_ATTACHMENT_REPAIR_FILE_DENIED') }}
      </p>
    </v-col>
    <v-row class="pa-3" no-gutters>
      <template v-if="checkPermission(['DISTRIBUTOR_VIEW_ATTACHMENT_REPAIR_FILE'])">
        <!--Card customerPackageEstimate-->
        <v-col cols="2" md="1"
               class="image-container"
               v-if="cardBox.customerPackageEstimate"
               @click.stop.prevent="getEstimateRepairPackagePdf()"
        >
          <img alt="pdf-svg"
               src="@/assets/icons/file/pdf.svg"
               class="image-pdf"
          />
          <div class="download-content">
            <img alt="download-svg"
                 src="@/assets/icons/file/download.svg"
                 class="image-download"
            />
          </div>
          <p class="content-text">
            {{ $t('REPAIR_FILE_ATTACHMENT.CARD.ESTIMATE_PACKAGE') }}
          </p>
        </v-col>

        <!--Card packingSlip-->
        <v-col cols="2" md="1"
               class="image-container"
               v-if="cardBox.packingSlip"
               @click.stop.prevent="getPackingSlipPdf()"
        >
          <img alt="pdf-svg"
               src="@/assets/icons/file/pdf.svg"
               class="image-pdf"
          />
          <div class="download-content">
            <img alt="download-svg"
                 src="@/assets/icons/file/download.svg"
                 class="image-download"
            />
          </div>
          <p class="content-text">
            {{ $t('REPAIR_FILE_ATTACHMENT.CARD.TRANSPORTER_ORDER') }}
          </p>
        </v-col>

        <!--Card orderRepairWaitingTransport-->
        <v-col cols="2" md="1"
               class="image-container"
               v-if="cardBox.orderRepairWaitingTransport"
               @click.stop.prevent="getRepairOrderWaitingTransportPdf()"
        >
          <img alt="pdf-svg"
               src="@/assets/icons/file/pdf.svg"
               class="image-pdf"
          />
          <div class="download-content">
            <img alt="download-svg"
                 src="@/assets/icons/file/download.svg"
                 class="image-download"
            />
          </div>
          <p class="content-text">
            {{ $t('REPAIR_FILE_ATTACHMENT.CARD.REPAIR_ORDER') }}
          </p>
        </v-col>

        <!--Card orderRepairWithTransport-->
        <v-col cols="2" md="1"
               class="image-container"
               v-if="cardBox.orderRepairWithTransport"
               @click.stop.prevent="getRepairOrderWithTransportPdf()"
        >
          <img alt="pdf-svg" src="@/assets/icons/file/pdf.svg" class="image-pdf" />
          <div class="download-content">
            <img
              alt="download-svg"
              src="@/assets/icons/file/download.svg"
              class="image-download"
            />
          </div>
          <p class="content-text">
            {{ $t('REPAIR_FILE_ATTACHMENT.CARD.REPAIR_ORDER') }}
          </p>
        </v-col>

        <!--Card orderRepairWithoutTransport-->
        <v-col cols="2" md="1"
               class="image-container"
               v-if="cardBox.orderRepairWithoutTransport"
               @click.stop.prevent="getRepairOrderWithoutTransportPdf()"
        >
          <img alt="pdf-svg"
               src="@/assets/icons/file/pdf.svg"
               class="image-pdf"
          />
          <div class="download-content">
            <img alt="download-svg"
                 src="@/assets/icons/file/download.svg"
                 class="image-download"
            />
          </div>
          <p class="content-text">
            {{ $t('REPAIR_FILE_ATTACHMENT.CARD.REPAIR_ORDER') }}
          </p>
        </v-col>

        <!--Card afterSaleService-->
        <v-col cols="2" md="1"
               class="image-container"
               v-if="cardBox.afterSaleService"
               @click.stop.prevent="getRepairAfterSaleServicePdf()"
        >
          <img alt="pdf-svg"
               src="@/assets/icons/file/pdf.svg"
               class="image-pdf"
          />
          <div class="download-content">
            <img alt="download-svg"
                 src="@/assets/icons/file/download.svg"
                 class="image-download"
            />
          </div>
          <p class="content-text">
            {{ $t('REPAIR_FILE_ATTACHMENT.CARD.AFTER_SALE_SERVICE') }}
          </p>
        </v-col>

        <!--Card customerBilling-->
        <v-col cols="2" md="1"
               class="image-container"
               v-if="cardBox.customerBilling"
               @click.stop.prevent="downloadFiles(currentRepairFile.product_buy_proof_file_path_aws)"
        >
          <img alt="pdf-svg"
               src="@/assets/icons/file/pdf.svg"
               class="image-pdf"
          />
          <div class="download-content">
            <img alt="download-svg"
                 src="@/assets/icons/file/download.svg"
                 class="image-download"
            />
          </div>
          <p class="content-text">
            {{ $t('REPAIR_FILE_ATTACHMENT.CARD.BILLING') }}
          </p>
        </v-col>

        <!--Card customerExtensionGuarantee-->
        <v-col cols="2" md="1"
               class="image-container"
               v-if="cardBox.customerExtensionGuarantee"
               @click.stop.prevent="downloadFiles(currentRepairFile.product_guarantee_extension_proof_file_path_aws)"
        >
          <img alt="pdf-svg"
               src="@/assets/icons/file/pdf.svg"
               class="image-pdf"
          />
          <div class="download-content">
            <img alt="download-svg"
                 src="@/assets/icons/file/download.svg"
                 class="image-download"
            />
          </div>
          <p class="content-text">
            {{ $t('REPAIR_FILE_ATTACHMENT.CARD.GUARANTEE') }}
          </p>
        </v-col>

        <!--Card customerForceExtensionGuarantee-->
        <v-col cols="2" md="1"
               class="image-container"
               v-if="cardBox.customerForceExtensionGuarantee"
               @click.stop.prevent="downloadFiles(currentRepairFile.product_force_support_proof_file_path_aws)"
        >
          <img alt="pdf-svg"
               src="@/assets/icons/file/pdf.svg"
               class="image-pdf"
          />
          <div class="download-content">
            <img alt="download-svg"
                 src="@/assets/icons/file/download.svg"
                 class="image-download"
            />
          </div>
          <p class="content-text">
            {{ $t('REPAIR_FILE_ATTACHMENT.CARD.FORCE_GUARANTEE') }}
          </p>
        </v-col>

        <!--Card asbestosDeclaration-->
        <v-col cols="2" md="1"
               class="image-container"
               v-if="cardBox.asbestosDeclaration"
               @click.stop.prevent="downloadFiles(currentRepairFile.product_asbestos_proof_file_path_aws)"
        >
          <img alt="pdf-svg"
               src="@/assets/icons/file/pdf.svg"
               class="image-pdf"
          />
          <div class="download-content">
            <img alt="download-svg"
                 src="@/assets/icons/file/download.svg"
                 class="image-download"
            />
          </div>
          <p class="content-text">
            {{ $t('REPAIR_FILE_ATTACHMENT.CARD.ASBESTOS') }}
          </p>
        </v-col>

        <!--Card MAX dangerous product label-->
        <v-col cols="2" md="1"
               class="image-container"
               v-if="cardBox.dangerLabel
                 && currentRepairFile?.packet_battery_watt_hour
                 && currentRepairFile?.packet_battery_watt_hour >= 100"
        >
          <a
            :href="`/danger-max-label.pdf`"
            download="Etiquette_produit_dangereux.pdf"
            class=" link-black"
          >
            <img alt="pdf-svg"
                 src="@/assets/icons/file/pdf.svg"
                 class="image-pdf"
            />
            <div class="download-content">
              <img alt="download-svg"
                   src="@/assets/icons/file/download.svg"
                   class="image-download"
              />
            </div>
            <p class="content-text">
              {{ $t('REPAIR_FILE_ATTACHMENT.CARD.DANGER_LABEL') }}
            </p>
          </a>
        </v-col>

        <!--Card MIN dangerous product label-->
        <v-col cols="2" md="1"
               class="image-container "
               v-if="cardBox.dangerLabel
                  && currentRepairFile?.packet_battery_watt_hour
                  && currentRepairFile?.packet_battery_watt_hour < 100"
        >
          <a
            :href="`/danger-min-label.pdf`"
            download="Etiquette_produit_dangereux.pdf"
            class=" link-black"
          >
            <img alt="pdf-svg"
                 src="@/assets/icons/file/pdf.svg"
                 class="image-pdf"
            />
            <div class="download-content">
              <img alt="download-svg"
                   src="@/assets/icons/file/download.svg"
                   class="image-download"
              />
            </div>
            <p class="content-text">
              {{ $t('REPAIR_FILE_ATTACHMENT.CARD.DANGER_LABEL') }}
            </p>
          </a>
        </v-col>

        <!--Card guarantee extension boomerang proof-->
        <v-col cols="2" md="1"
               class="image-container"
               v-if="cardBox.guaranteeExtensionBoomerangProof"
               @click.stop.prevent="getGuaranteeExtensionBoomerangPdf()"
        >
          <img alt="pdf-svg"
               src="@/assets/icons/file/pdf.svg"
               class="image-pdf"
          />
          <div class="download-content">
            <img alt="download-svg"
                 src="@/assets/icons/file/download.svg"
                 class="image-download"
            />
          </div>
          <p class="content-text">
            {{ $t('REPAIR_FILE_ATTACHMENT.CARD.GUARANTEE_EXTENSION_BOOMERANG') }}
          </p>
        </v-col>

        <!--Card list of additional Attachment-->
        <template :key="additionalAttachment.technical_id"
                  v-for="additionalAttachment of additionalAttachmentList"
        >
          <v-col cols="2" md="1"
                 class="image-container"
                 @click.stop.prevent="downloadFiles(additionalAttachment.file_path)"
          >
            <img alt="pdf-svg"
                 src="@/assets/icons/file/pdf.svg" class="image-pdf"
            />
            <div class="download-content">
              <img alt="download-svg"
                   src="@/assets/icons/file/download.svg"
                   class="image-download"
              />
            </div>
            <p class="content-text">
              {{ additionalAttachment.name }}
            </p>
          </v-col>
        </template>

        <!--Card list of prospect picture-->
        <template :key="prospectPicture.technicalId"
                  v-for="prospectPicture of prospectPictureList"
        >
          <v-col cols="2" md="1"
                 class="image-container"
                 @click.stop.prevent="downloadFiles(prospectPicture.filePath)"
          >
            <img alt="pdf-svg"
                 src="@/assets/icons/file/file-2.svg" class="image-pdf"
            />
            <div class="download-content">
              <img alt="download-svg"
                   src="@/assets/icons/file/download.svg"
                   class="image-download"
              />
            </div>
            <p class="content-text">
              {{ $t('REPAIR_FILE_ATTACHMENT.PROSPECT_PICTURE_NAME_LABEL') }}{{ prospectPicture.pictureCounter }}
            </p>
          </v-col>
        </template>

        <!--Card list of prospect document-->
        <template :key="prospectDocument.technicalId"
                  v-for="prospectDocument of prospectDocumentList"
        >
          <v-col cols="2" md="1"
                 class="image-container"
                 @click.stop.prevent="downloadFiles(prospectDocument.filePath)"
          >
            <img alt="pdf-svg"
                 src="@/assets/icons/file/file-2.svg" class="image-pdf"
            />
            <div class="download-content">
              <img alt="download-svg"
                   src="@/assets/icons/file/download.svg"
                   class="image-download"
              />
            </div>
            <p class="content-text">
              {{ $t('REPAIR_FILE_ATTACHMENT.PROSPECT_DOCUMENT_NAME_LABEL') }}{{ prospectDocument.documentCounter }}
            </p>
          </v-col>
        </template>

        <!--Card prospect manufacturer attachment-->
        <template v-if="prospectManufacturerAttachment">
          <v-col cols="2" md="1"
                 class="image-container"
                 @click.stop.prevent="downloadFiles(prospectManufacturerAttachment)"
          >
            <img alt="pdf-svg"
                 src="@/assets/icons/file/file-2.svg" class="image-pdf"
            />
            <div class="download-content">
              <img alt="download-svg"
                   src="@/assets/icons/file/download.svg"
                   class="image-download"
              />
            </div>
            <p class="content-text">
              {{ currentRepairFile.prospect_manufacturer_attachment_filename }}
            </p>
          </v-col>
        </template>

        <!--Card RepairFileProspectOrderWaiting-->
        <v-col cols="2" md="1"
               class="image-container"
               v-if="cardBox.repairFileProspectOrderWaiting"
               @click.stop.prevent="getRepairFileProspectOrderWaitingPdf()"
        >
          <img alt="pdf-svg"
               src="@/assets/icons/file/pdf.svg"
               class="image-pdf"
          />
          <div class="download-content">
            <img alt="download-svg"
                 src="@/assets/icons/file/download.svg"
                 class="image-download"
            />
          </div>
          <p class="content-text">
            {{ $t('REPAIR_FILE_ATTACHMENT.CARD.REPAIR_FILE_PROSPECT_ORDER_WAITING') }}
          </p>
        </v-col>
      </template>

      <!--Card add attachment-->
      <template v-if="checkPermission(['DISTRIBUTOR_ADD_ATTACHMENT_REPAIR_FILE'])">
        <v-col cols="2" md="1"
               class="add-attachment"
        >
          <div @click.stop.prevent="openInputModal()"
               class="add-attachment-content"
          >
            <img class="cross-round-svg"
                 alt="cross-round-svg"
                 src="@/assets/icons/file/cross_round.svg"
            />
          </div>
        </v-col>
      </template>
    </v-row>
  </v-card>

  <UploadAdditionalAttachmentModal ref="uploadAdditionalAttachmentModal" />
</template>

<script>
import TransportModalityConstant from '@/constants/transportModalityConstant'
import TransportTypeConstant from '@/constants/transportTypeConstant'
import PdfService from '@/services/PdfService'
import RepairFileStatusDetailConstant from '@/constants/repairFileStatusDetailConstant'
import { displayToast, checkPermission, handleResponseError } from '@/components/utils/globalFunction'
import UploadAdditionalAttachmentModal from '@/components/modal/repair-file/UploadAdditionalAttachmentModal.vue'
import RepairFileService from '@/services/RepairFileService'
import { RepairFile } from '@/models/RepairFile'
import ExpressistTransporterService from '@/services/transporters/ExpressistTransporterService'
import FolderTypeConstant from '@/constants/repairModule/FolderTypeConstant'

export default {
  name: 'AttachmentRepairFile',
  components: { UploadAdditionalAttachmentModal },
  props: {
    currentRepairFile: RepairFile
  },
  data() {
    return {
      cardBox: {
        packingSlip: false,
        orderRepairWaitingTransport: false,
        orderRepairWithTransport: false,
        orderRepairWithoutTransport: false,
        customerBilling: false,
        customerExtensionGuarantee: false,
        customerForceExtensionGuarantee: false,
        asbestosDeclaration: false,
        afterSaleService: false,
        dangerLabel: false,
        customerPackageEstimate: false,
        guaranteeExtensionBoomerangProof: false,
        repairFileProspectOrderWaiting: false
      },
      additionalAttachmentList: [],
      prospectPictureList: [],
      prospectDocumentList: [],
      prospectManufacturerAttachment: null
    }
  },
  async created() {
    this.patchShowCard()
    if (this.checkPermission(['DISTRIBUTOR_VIEW_ATTACHMENT_REPAIR_FILE'])) {
      await this.getRepairFileAdditionalAttachment()
      this.prospectPictureList = this.currentRepairFile.prospect_picture_list
      this.prospectDocumentList = this.currentRepairFile.prospect_document_list
      this.prospectManufacturerAttachment = this.currentRepairFile.prospect_manufacturer_attachment_path
    }
  },
  methods: {
    checkPermission,
    openInputModal() {
      this.$refs.uploadAdditionalAttachmentModal.show({
        repairFileId: this.currentRepairFile.technical_id,
      }).then(async (result) => {
        if (result.confirmed) {
          if (this.checkPermission(['DISTRIBUTOR_VIEW_ATTACHMENT_REPAIR_FILE'])) {
            await this.getRepairFileAdditionalAttachment()
          }
        }
      })
    },
    patchShowCard() {
      if (this.currentRepairFile.initial_transporter_modality === TransportModalityConstant.WORKSHOP
        || this.currentRepairFile.initial_transporter_modality === TransportModalityConstant.STORE
        || this.currentRepairFile.initial_transporter_modality === TransportModalityConstant.EXCLUDING_SUPPORT) {
        this.cardBox.orderRepairWithoutTransport = true
        this.cardBox.afterSaleService = true
      }

      if (this.currentRepairFile.initial_transporter_modality === TransportModalityConstant.TRANSPORTER) {
        if (this.currentRepairFile.initial_transporter_type === TransportTypeConstant.CUSTOMER_SERVICE_TRANSPORTER) {
          this.cardBox.orderRepairWaitingTransport = true
          this.cardBox.afterSaleService = true
        }
        if (this.currentRepairFile.initial_transporter_type === TransportTypeConstant.WITHOUT_TRANSPORTER) {
          this.cardBox.orderRepairWithoutTransport = true
          this.cardBox.afterSaleService = true
        }
        if (this.currentRepairFile.initial_transporter_type === TransportTypeConstant.IMMEDIATE_TRANSPORTER) {
          this.cardBox.orderRepairWithTransport = true
          this.cardBox.afterSaleService = true
          if (this.currentRepairFile?.tracking_number) {
            this.cardBox.packingSlip = true
          }
        }
      }

      if (this.currentRepairFile.product_asbestos_proof_file_path) {
        this.cardBox.asbestosDeclaration = true
      }

      if (this.currentRepairFile.product_buy_proof_file_path) {
        this.cardBox.customerBilling = true
      }

      if (this.currentRepairFile.product_guarantee_extension_proof_file_path) {
        this.cardBox.customerExtensionGuarantee = true
      }

      if (this.currentRepairFile.product_force_support_proof_file_path) {
        this.cardBox.customerForceExtensionGuarantee = true
      }

      if (this.currentRepairFile?.packet_battery_watt_hour) {
        this.cardBox.dangerLabel = true
      }

      if (this.currentRepairFile.status_detail === RepairFileStatusDetailConstant.PRICING_SENT_TO_CUSTOMER) {
        this.cardBox.customerPackageEstimate = true
      }

      if (this.currentRepairFile.guarantee_extension_boomerang_proof) {
        this.cardBox.guaranteeExtensionBoomerangProof = true
      }

      if (this.currentRepairFile.folder_type === FolderTypeConstant.PROSPECT_FOLDER) {
        this.cardBox.repairFileProspectOrderWaiting = true
      }
    },
    async downloadFiles(file_url) {
      if (!this.checkPermission(['DISTRIBUTOR_PRINT_ATTACHMENT_REPAIR_FILE'])) {
        displayToast(this.$t('REPAIR_FILE_ATTACHMENT.PERMISSION.PRINT_ATTACHMENT_REPAIR_FILE_DENIED'), 'error')
      } else {
        if (file_url) {
          const a = document.createElement('a')
          a.style.display = 'none'
          a.href = file_url
          document.body.appendChild(a)
          a.click()
          await new Promise((resolve) => setTimeout(resolve, 500))
          document.body.removeChild(a)
        }
      }
    },
    async getRepairAfterSaleServicePdf() {
      if (!this.checkPermission(['DISTRIBUTOR_PRINT_ATTACHMENT_REPAIR_FILE'])) {
        displayToast(this.$t('REPAIR_FILE_ATTACHMENT.PERMISSION.PRINT_ATTACHMENT_REPAIR_FILE_DENIED'), 'error')
      } else {
        this.loading = true
        try {
          const response = await PdfService.getRepairPackagePdf(this.currentRepairFile.boomerang_id)
          const url = window.URL.createObjectURL(new Blob([response]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'fiche_sav_client_'
            + this.currentRepairFile.internal_command_number + '.pdf')
          document.body.appendChild(link)
          link.click()
        } catch (error) {
          handleResponseError(error)
        } finally {
          this.loading = false
        }
      }
    },
    async getRepairOrderWaitingTransportPdf() {
      if (!this.checkPermission(['DISTRIBUTOR_PRINT_ATTACHMENT_REPAIR_FILE'])) {
        displayToast(this.$t('REPAIR_FILE_ATTACHMENT.PERMISSION.PRINT_ATTACHMENT_REPAIR_FILE_DENIED'), 'error')
      } else {
        try {
          this.loading = true
          const response = await PdfService.getRepairOrderWaitingTransportPdf(this.currentRepairFile.boomerang_id)
          const url = window.URL.createObjectURL(new Blob([response]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'ordre_de_réparation_'
            + this.currentRepairFile.internal_command_number + '.pdf')
          document.body.appendChild(link)
          link.click()
        } catch (error) {
          handleResponseError(error)
        } finally {
          this.loading = false
        }
      }
    },
    async getRepairOrderWithTransportPdf() {
      if (!this.checkPermission(['DISTRIBUTOR_PRINT_ATTACHMENT_REPAIR_FILE'])) {
        displayToast(this.$t('REPAIR_FILE_ATTACHMENT.PERMISSION.PRINT_ATTACHMENT_REPAIR_FILE_DENIED'), 'error')
      } else {
        try {
          this.loading = true
          const response = await PdfService.getRepairOrderWithTransportPdf(this.currentRepairFile.boomerang_id)
          const url = window.URL.createObjectURL(new Blob([response]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'ordre_de_réparation_'
            + this.currentRepairFile.internal_command_number + '.pdf')
          document.body.appendChild(link)
          link.click()
        } catch (error) {
          handleResponseError(error)
        } finally {
          this.loading = false
        }
      }
    },
    async getRepairOrderWithoutTransportPdf() {
      if (!this.checkPermission(['DISTRIBUTOR_PRINT_ATTACHMENT_REPAIR_FILE'])) {
        displayToast(this.$t('REPAIR_FILE_ATTACHMENT.PERMISSION.PRINT_ATTACHMENT_REPAIR_FILE_DENIED'), 'error')
      } else {
        try {
          this.loading = true
          const response = await PdfService.getRepairOrderWithoutTransportPdf(this.currentRepairFile.boomerang_id)
          const url = window.URL.createObjectURL(new Blob([response]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'ordre_de_réparation_'
            + this.currentRepairFile.internal_command_number + '.pdf')
          document.body.appendChild(link)
          link.click()
        } catch (error) {
          handleResponseError(error)
        } finally {
          this.loading = false
        }
      }
    },
    async getPackingSlipPdf() {
      if (!this.checkPermission(['DISTRIBUTOR_PRINT_ATTACHMENT_REPAIR_FILE'])) {
        displayToast(this.$t('REPAIR_FILE_ATTACHMENT.PERMISSION.PRINT_ATTACHMENT_REPAIR_FILE_DENIED'), 'error')
      } else {
        try {
          this.loading = true
          const response = await ExpressistTransporterService
            .getPackingSlip(this.currentRepairFile.boomerang_id)
          const url = window.URL.createObjectURL(new Blob([response]))
          const link = document.createElement('a')
          const filename = 'etiquette_transport_' + this.currentRepairFile.internal_command_number + '.pdf'
          link.href = url
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
        } catch (error) {
          handleResponseError(error)
        } finally {
          this.loading = false
        }
      }
    },
    async getEstimateRepairPackagePdf() {
      if (!this.checkPermission(['DISTRIBUTOR_PRINT_ATTACHMENT_REPAIR_FILE'])) {
        displayToast(this.$t('REPAIR_FILE_ATTACHMENT.PERMISSION.PRINT_ATTACHMENT_REPAIR_FILE_DENIED'), 'error')
      } else {
        const response = await PdfService.getRepairPackageWaitingPdf(this.currentRepairFile.boomerang_id)
        const url = window.URL.createObjectURL(new Blob([response]))
        const link = document.createElement('a')
        link.href = url
        const now_date = new Date().toLocaleDateString('fr-FR',
          { year: 'numeric', month: '2-digit', day: '2-digit' })
        link.setAttribute('download', 'devis_forfait_' + now_date + '.pdf')
        document.body.appendChild(link)
        link.click()
      }
    },
    async getRepairFileAdditionalAttachment() {
      try {
        const response = await RepairFileService.getAdditionalAttachmentFileList(this.currentRepairFile.technical_id)
        this.additionalAttachmentList = response.item_list
      } catch (error) {
        handleResponseError(error)
      }
    },
    async getGuaranteeExtensionBoomerangPdf() {
      try {
        this.loading = true
        const response = await PdfService.getGuaranteeExtensionBoomerangPdf(this.currentRepairFile.boomerang_id)
        const url = window.URL.createObjectURL(new Blob([response]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'certificat_prolongation_garantie_boomerang_'
          + this.currentRepairFile.internal_command_number + '.pdf')
        document.body.appendChild(link)
        link.click()
      } catch (error) {
        handleResponseError(error)
      } finally {
        this.loading = false
      }
    },
    async getRepairFileProspectOrderWaitingPdf() {
      if (!this.checkPermission(['DISTRIBUTOR_PRINT_ATTACHMENT_REPAIR_FILE'])) {
        displayToast(this.$t('REPAIR_FILE_ATTACHMENT.PERMISSION.PRINT_ATTACHMENT_REPAIR_FILE_DENIED'), 'error')
      } else {
        try {
          this.loading = true
          const response = await PdfService.getRepairPackageWaitingPdf(this.currentRepairFile.boomerang_id)
          const url = window.URL.createObjectURL(new Blob([response]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'Demande_préalable_'
            + this.currentRepairFile.internal_command_number + '.pdf')
          document.body.appendChild(link)
          link.click()
        } catch (error) {
          handleResponseError(error)
        } finally {
          this.loading = false
        }
      }
    }
  }
}
</script>

<style scoped>
.add-attachment {
  margin-left: 10px;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 20px;
  border: 1px dashed #559A1B;
  cursor: pointer;
}

.add-attachment-content {
  align-items: center;
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  border-radius: 50px;
  box-shadow: 6px 6px 12px 0 rgba(218, 218, 218, 0.40);
}

.cross-round-svg {
  width: 12px;
  height: 12px;
}

.attachment-repair-file {
  min-height: 196px;
}

.v-card {
  padding: 10px 20px;
}

.content-text {
  text-align: center;
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.content-text:first-letter {
  text-transform: uppercase;
}

.image-container {
  cursor: pointer;
  margin-bottom: 10px;
  max-height: 140px;
  position: relative;
}

.image-pdf {
  display: flex;
  margin: auto auto 30px;
  position: relative;
  width: 56px;
  height: 56px;
}

.download-content {
  position: absolute;
  top: 50px;
  left: 24px;
  width: 32px;
  height: 32px;
  background: white;
  border-radius: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.image-download {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 12px;
  height: 12px;
}

.title {
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.link-black {
  color: rgba(0, 0, 0, 0.87);
  text-decoration: unset;
}

.sub-title {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  display: flex;
}
</style>
